module.exports = __webpack_public_path__ + "img/imgRemove04.f8fbc277.png";